module.exports = __webpack_public_path__ + "img/qualification.ab1b60a6.jpg";